<template>
  <div class="distribute">
    <el-card class="box-tab">
      <el-tabs v-model="form.is_assign" @tab-click="changeTaskType">
        <el-tab-pane :label="`待分配(${dataInfo.not_assign_total})`" name="0"></el-tab-pane>
        <el-tab-pane :label="`已分配(${dataInfo.has_assign_total})`" name="1"></el-tab-pane>
      </el-tabs>
    </el-card>
    <el-card class="search-form">
      <el-form label-position="left" label-width="130px" :model="form">
        <el-row>
          <el-col :span="8">
            <el-form-item>
              <div slot="label" class="form-label">
                模考名称/ID:
              </div>
              <el-input v-model="form.search_text" placeholder="请输入名称/ID" maxlength=20 clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <div slot="label" class="form-label">
                学员手机号:
              </div>
              <el-input v-model="form.phone" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" >
            <el-form-item>
              <div slot="label" class="form-label">
                提交时间:
              </div>
              <div style="width: 100%; display:flex; justify-content: space-between;">
                <el-date-picker
                  style="flex: 0 0 45%"
                  :picker-options="pickerOptions_begin"
                  v-model="form.submit_time_begin"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="开始日期">
                </el-date-picker>
                <span>~</span>
                <el-date-picker
                  style="flex: 0 0 45%"
                  :picker-options="pickerOptions_end"
                  v-model="form.submit_time_end"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="结束日期">
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" v-if="form.is_assign == '1'">
            <el-form-item>
              <div slot="label" class="form-label">
              </div>
              <el-select v-model="form.correct_status" placeholder="批改状态" class="my-select">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="form.is_assign == '1'">
            <el-form-item>
              <div slot="label" class="form-label">
                批改老师:
              </div>
              <el-input v-model="form.correct_user" placeholder="请输入姓名/工号" maxlength=20 clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="form.is_assign == '0' ? 16 : 0">
            <div class="button-group">
              <el-button type="primary" @click="search">查询</el-button>
              <el-button @click="initForm">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="box-card">
      <div class="operation-box">
        <el-button class="btn-distribute" v-if="form.is_assign == '0'" @click="openDistributeLayout('more', correct_collection_ids)">
          <i class="el-icon-document"></i>分配批改任务
        </el-button>
          <p class="num">{{isSearch ? `共筛选出${total}条数据` : `共${total}条数据`}}</p>
      </div>
      <el-table
        :data="dataInfo.list"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="批改任务">
          <template slot-scope="scope">
            <div>
              <p class="mock-name"><span>模考</span>{{scope.row.mock_name}}</p>
              <p class="mock-info">
                <span>模考ID：{{scope.row.mock_id}}</span> |
                <el-popover
                  placement="top-start"
                  title=""
                  width="300"
                  trigger="hover"
                  :content="`模考科目：${scope.row.mock_subject_name}`">
                  <span slot="reference" class="mock-course">模考科目：{{scope.row.mock_subject_name}}</span>
                </el-popover>
              </p>
              <el-popover
                placement="top-start"
                title=""
                width="300"
                trigger="hover">
                <div>
                  <p>考试：{{scope.row.mock_name}}</p>
                  <p>子模考：{{scope.row.mock_sub_name}}</p>
                </div>
                <span slot="reference" class="mock-child blue">子模考</span>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="submit_time" label="提交时间">
        </el-table-column>
        <el-table-column label="学员信息">
          <template slot-scope="scope">
            <div>
              <p class="user-name">{{scope.row.student_name}}</p>
              <p>{{scope.row.student_phone}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="批改老师" v-if="form.is_assign == '1'">
          <template slot-scope="scope">
            <div>
              <p>{{scope.row.correct_user_name}}</p>
              <p>{{scope.row.correct_user_job_number}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="批改状态" v-if="form.is_assign == '1'">
          <template slot-scope="scope">
            <p :class="[scope.row.is_release == 1 ? 'already' : 'not']">{{scope.row.is_release == 1 ? '已批改' : '待批改'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <div class="box-operate" v-if="form.is_assign == '0'">
              <a href="javascript:void(0);" class="blue" @click="openDistributeLayout('single', scope.row)">分配</a>
              <span class="divide-line">|</span>
              <a href="javascript:void(0);" class="blue" @click="confirmClaim(scope.row)">认领</a>
            </div>
            <div v-else>
              <p class="blue" @click="goToDetail(scope.row)">{{scope.row.is_release == 1 ? '批改详情' : ''}}</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination class="paginationblock"
                     layout="prev, pager, next, sizes, jumper"
                     background
                     :page-size="pageInfo.size"
                     :page-sizes="[20, 50, 100]"
                     :total="total"
                     :current-page="pageInfo.page"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange">
      </el-pagination>
    </el-card>
    <!--  分配批改老师弹窗  -->
    <el-dialog title="分配批改老师" :visible.sync="dialogTeachers" @close="cancelDistribute">
      <div>
        <el-row class="box-search">
          <el-col :span="8">
            <el-input v-model="teacher.teacherInfo" placeholder="请输入姓名/工号/手机号"></el-input>
          </el-col>
          <el-col :span="8" :offset="8">
            <div class="button-group">
              <el-button type="primary" @click="getTeacherList">查询</el-button>
              <el-button @click="initTeacher">重置</el-button>
            </div>
          </el-col>
        </el-row>
        <el-table :data="teacherList" height="250">
          <el-table-column label="基本信息">
            <template slot-scope="scope">
              <el-radio v-model="teacher.teacher_job_number" :label="scope.row.job_number">{{`${scope.row.teacher_name}(${scope.row.job_number})`}}</el-radio>
            </template>
          </el-table-column>
          <el-table-column property="not_correct_number" label="待批改任务"></el-table-column>
        </el-table>
        <div class="button-group">
          <el-button @click="cancelDistribute">取消</el-button>
          <el-button type="primary" @click="distributeTask('distribute')">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "Distribute",
    data () {
      return {
        form: {
          is_assign: '0',
          search_text: '',
          submit_time_begin: '',
          submit_time_end: '',
          phone: '',
          correct_status: null,
          correct_user: ''
        },
        pageInfo: {
          size: 20,
          page: 1
        },
        total: 0,
        dataInfo: {
          not_assign_total: 0,
          has_assign_total: 0,
        },
        dialogTeachers: false,
        teacher: {
          teacherInfo: '',
          teacher_job_number: '',
        },
        teacherList: [],
        correct_collection_ids: [],
        phone: '',
        options: [
          {
            label: '待批改',
            value: 0
          },
          {
            label: '已批改',
            value: 1
          }
        ],
        multipleSelection: [],
        isSearch: false
      }
    },
    filters: {
      // 作答用时格式化,以秒为单位
      timeFormat (value) {
        var time = value;
        var h = parseInt(time / 3600),
          m = parseInt(time % 3600 / 60),
          s = parseInt(time % 60);
        h = h < 10 ? "0"+ h : h;
        m = m < 10 ? "0"+ m : m;
        s = s < 10 ? "0"+ s : s;
        return `用时：${h}:${m}:${s}`;
      }
    },
    computed: {
      pickerOptions_begin () {
        console.log(this.form);
        var _this = this;
        if (_this.form.release_time_end) {
          return {
            disabledDate(time) {
              return time.getTime() >= new Date(_this.form.release_time_end).getTime();
            }
          }
        }
        return {};

      },
      pickerOptions_end () {
        var _this = this;
        if (_this.form.release_time_begin) {
          return {
            disabledDate(time) {
              return time.getTime() <= new Date(_this.form.release_time_begin).getTime();
            }
          }
        }
        return {};
      }
    },
    mounted(){
      this.getDataList()
    },
    methods: {
      changeTaskType () {
        this.initForm()
      },
      // 查询
      search () {
        this.pageInfo.page = 1;
        this.getDataList();
        this.isSearch = true
      },
      // 获取批改任务分配列表
      getDataList () {
        var params = {...this.form, ...this.pageInfo}

        this.$api.GETCORRECTLISTZJ(params).then((res) => {
          if (res.retcode == 0) {
            this.dataInfo = res.data;
            this.total = res.data.search_total;
          }
          else{
            this.$message.error(res.message);
          }
        })
      },
      // 重置
      initForm () {
        this.form = {
          is_assign: this.form.is_assign,
          search_text: '',
          submit_time_begin: '',
          submit_time_end: '',
          phone: '',
          correct_status: null,
          correct_user: ''
        };
        this.pageInfo.page = 1;
        this.search()
        this.isSearch = false
      },
      initTeacher () {
        this.teacher = {}
        this.teacherList = []
      },
      // 取消分配
      cancelDistribute () {
        this.dialogTeachers = false
        // 清除表格勾选项
        this.$refs.multipleTable.clearSelection()
        this.initTeacher()
      },
      // 切换每页条目数
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageInfo.size = val;
        // this.search();
      },
      // 当前页面page参数发生改变
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.pageInfo.page = val;
        this.getDataList();
      },
      // 选择任务
      handleSelectionChange (val) {
        var arr = []
        arr = val.map(item => {
          return item.correct_collection_id
        })
        this.correct_collection_ids = arr
      },
      openDistributeLayout (type, row) {
        if (type == 'single') {
          this.$refs.multipleTable.toggleRowSelection(row, true); //row 选中
        }
        if (this.correct_collection_ids.length == 0) {
          this.$message.error('请选择批改任务！');
          return
        }
        else {
          this.dialogTeachers = true
        }
      },
      // 点击分配获取批改老师列表
      getTeacherList () {
        if (this.teacher.teacherInfo == '') {
          this.$message.error('请先输入搜索条件！')
          return
        }
        this.$api.GETCORRECTTEACHERLIST( {
          search_text: this.teacher.teacherInfo
        }).then((res) => {
          if (res.retcode == 0) {
            this.teacherList = res.data
          }
          else{
            this.$message.error(res.message);
          }
        })
      },
      // 分配任务
      distributeTask (type) {
        if (type == 'distribute' && this.teacher.teacher_job_number === '') {
          this.$message.error('请选择老师，再进行分配！')
          return
        }
        this.$api.CORRECTASSIGN({
          job_number: this.teacher.teacher_job_number,
          correct_collection_ids: this.correct_collection_ids.join(',')
        }).then((res) => {
          if (res.retcode == 0) {
            this.$message.success(type == 'distribute' ? '任务分配成功！' : '任务认领成功');
            this.dialogTeachers = false
            this.initTeacher()
            this.search()
          }
          else{
            this.$message.error(res.message);
          }
        })
      },
      // 确认认领
      confirmClaim (row) {
        this.$refs.multipleTable.toggleRowSelection(row, true); //row 选中
        this.$confirm('确认要认领此条任务吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          this.distributeTask()
        })
        .catch(() => {
          // 清除表格勾选项
          this.$refs.multipleTable.clearSelection()
        });
      },
      // 跳转批改详情
      goToDetail (row) {
        console.log(row, '111111111111111')
        const view = this.$router.resolve({
          path: `/jw-mock/${row.exercise_id}/${row.mock_id}/${row.paper_id}/${row.sso_id}/${row.correct_user_job_number}/${row.record_id}?correct_from=2`
        })
        window.open(view.href)
      }
    },
  }
</script>

<style lang="less" scoped>
  .distribute {
    /deep/ .box-tab {
      margin-bottom: 22px;
      .el-card__body {
        padding: 0;
        .el-tabs {
          .el-tabs__header {
            margin-bottom: 0;
            padding: 10px 20px 0;
            background-color: #ffffff;
            .el-tabs__nav-wrap::after {
              background-color: #ffffff;
            }
          }
        }
      }
    }
    .search-form {
      background-color: #fff;
      padding-top: 22px;
      margin-bottom: 22px;
      .form-label {
        text-align: right;
        padding-right: 10px;
      }
      .my-select {
        width: 100%;
      }
      .button-group {
        display: flex;
        justify-content: flex-end;
      }
    }
    .box-card {
      .line-clamp {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .operation-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .num {
          flex: 1;
          text-align: right;
        }
      }
      .el-table {
        p {
          margin: 0;
        }
        .mock-name {
          font-size: 16px;
          span {
            margin-right: 2px;
            padding: 2px;
            font-size: 12px;
            color: #ffffff;
            background-color: #ff9966;
            border-radius: 4px;
          }
        }
        .mock-info {
          font-size: 12px;
          color: #BCBCBC;
          .mock-course {
            display: inline-block;
            width: 120px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            cursor: pointer;
            vertical-align: middle;
          }
        }
        .mock-child {
          font-size: 12px;
        }
        .box-operate {
          a {
            text-decoration: none;
          }
          .divide-line {
            color: #BCBCBC;
            padding: 0 5px;
          }
        }
        .already {
          color: #52C41A;
        }
        .not {
          color: #FF9966;
        }
      }
      .paginationblock{
        padding: 20px 0;
        text-align: right;
        background-color: #fff;
      }
    }
    /deep/ .el-dialog {
      border-radius: 5px;
      .el-dialog__header {
        position: relative;
        padding: 10px 20px;
        border-bottom: 1px solid #eee;
        .el-dialog__headerbtn {
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .box-search {
        margin-bottom: 20px;
      }
      .el-table {
        margin-bottom: 10px;
      }
      .button-group {
        text-align: right;
      }
    }
  }
</style>
<style>
  .blue{
    color: #1890ff;
    cursor: pointer;
  }
  .distribute .has-gutter tr{
    border: 1px solid #eee;
  }
  .distribute .has-gutter tr th{
    background-color: #eee;
  }
</style>











































// WEBPACK FOOTER //
// src/pages/jk-correction-task/distribute.vue